const tNamespace = "error:slots."

export const SLOT_API_ERROR_MESSAGES = {
    GET: `${tNamespace}fetch-slot-page-failed`,
    CREATE: `${tNamespace}create-slot-failed`,
    UPDATE: `${tNamespace}update-slot-failed`,
    DELETE: `${tNamespace}delete-slot-failed`
}
